import React from "react";

export const HandlePrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      role="button"
      tabIndex={0}
      className={`arrow ${className}`}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === "Space") {
          onClick();
        }
      }}
    >
      <img src="/prev-arrow.svg" alt="Prev" width={42} height={13} />
    </div>
  );
};

export const HandleNextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div
      role="button"
      tabIndex={0}
      className={`arrow ${className} ${props?.extraClasses} me-2`}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === "Space") {
          onClick();
        }
      }}
    >
      <img
        loading="lazy"
        src="/next-arrow.svg"
        alt="Next"
        width={42}
        height={13}
      />
    </div>
  );
};
